import { userRequest } from '../requestMethods';
import config from '../config';

const DOMAIN = config.REACT_APP_SERVER_DOMAIN;

export const getOffre = async () => {
    return userRequest.get(`${DOMAIN}/api/offre`);
  };

  export const getOffreDoc = async () => {
    return userRequest.get(`${DOMAIN}/api/offre/offre_doc`);
  };

  export const getOffreArticle = async () => {
    return userRequest.get(`${DOMAIN}/api/offre/offre_article`);
  };

  export const getOffreArticleOne = async (id) => {
    return userRequest.get(`${DOMAIN}/api/offre/one_offre?id_offre=${id}`);
  };

export const getDetailDoc = async (id) => {
    return userRequest.get(`${DOMAIN}/api/offre/detailOffre?id_offre=${id}`);
  };

export const getOffreDetail = async (id) => {
    return userRequest.get(`${DOMAIN}/api/offre/detail?id_offre=${id}`);
  };

export const postOffre = async (data) => {
  return userRequest.post(`${DOMAIN}/api/offre`, data);
};


export const postOffreDoc = async (data) => {
    return userRequest.post(`${DOMAIN}/api/offre/doc`, data);
  };
  
export const postArticle = async (data) => {
    return userRequest.post(`${DOMAIN}/api/offre/articles`, data);
  };

  export const postArticleExcel = async (data) => {
    console.log(data)
    return userRequest.post(`${DOMAIN}/api/offre/article_excel`, data,{
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  };

export const postOffreArticle = async (data) => {
    return userRequest.post(`${DOMAIN}/api/offre/article`, data);
  };

export const estSupprimeArticle = async (id) => {
    return userRequest.put(`${DOMAIN}/api/offre/est_supprime_article?id=${id}`);
  };

export const estSupprimeOffre = async (id) => {
    return userRequest.put(`${DOMAIN}/api/offre/est_supprime?id=${id}`);
  };

export const deleteOffre = async (id) => {
    return userRequest.delete(`${DOMAIN}/api/offre/${id}`);
  };